import type {
  ImportExportV1BulkAssetUploadExecuteCreateData,
  ImportExportV1BulkAssetUploadListData,
  ImportExportV1BulkAssetUploadRowsListData,
  ImportExportV1BulkAssetUploadUploadTypeListData,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const bulkUpload = {
  search: {
    queryKey: 'import-export-service/bulk-asset-upload',
    fn: async () => {
      const response = await GatewayAxiosClient.get<ImportExportV1BulkAssetUploadListData>(
        `/import-export-proxy/api/v1/bulk-asset-upload`,
      );
      return response.data;
    },
  },
  getUploadTypes: {
    queryKey: 'import-export-service/bulk-asset-upload/upload-type',
    fn: async () => {
      const response = await GatewayAxiosClient.get<ImportExportV1BulkAssetUploadUploadTypeListData>(
        `/import-export-proxy/api/v1/bulk-asset-upload/upload-type`,
      );
      return response.data;
    },
  },
  getRows: {
    queryKey: 'import-export-service/bulk-asset-upload/id/rows',
    fn: async (bulkProcessingUploadId: string) => {
      const response = await GatewayAxiosClient.get<ImportExportV1BulkAssetUploadRowsListData>(
        `/import-export-proxy/api/v1/bulk-asset-upload/${bulkProcessingUploadId}/rows`,
      );
      return response.data;
    },
  },
  create: async (payload: ImportExportV1BulkAssetUploadExecuteCreateData) => {
    const { data } = await GatewayAxiosClient.post<ImportExportV1BulkAssetUploadListData[number]>(
      `/import-export-proxy/api/v1/bulk-asset-upload`,
      payload,
    );

    return { data, invalidateQueryKeys: [['import-export-service/bulk-asset-upload']] };
  },
  execute: async (bulkProcessingUploadId: string) => {
    const response = await GatewayAxiosClient.post<ImportExportV1BulkAssetUploadListData>(
      `/import-export-proxy/api/v1/bulk-asset-upload/${bulkProcessingUploadId}/execute`,
    );

    return {
      data: response.data,
      invalidateQueryKeys: [
        ['import-export-service/bulk-asset-upload'],
        ['import-export-service/bulk-asset-upload/id/rows', bulkProcessingUploadId],
      ],
    };
  },
};
